export default "__VITE_ASSET__BV48pYLt__"